import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';
import type { SanityImageSource } from '@sanity/image-url/lib/types/types';

const projectId = import.meta.env?.VITE_SANITY_STUDIO_PROJECT_ID || 'projectId';
const PREVIEW_TOKEN = import.meta.env?.VITE_SANITY_PREVIEW_API_TOKEN;
const isDraftsModeEnabled =
  import.meta.env?.VITE_SANITY_PREVIEW_ENABLED === 'true';

if (!projectId) {
  throw new Error(
    'VITE_SANITY_STUDIO_PROJECT_ID environment variable is required',
  );
}

if (isDraftsModeEnabled && !PREVIEW_TOKEN) {
  throw new Error(
    'VITE_SANITY_PREVIEW_API_TOKEN environment variable is required when preview mode is enabled',
  );
}

export const client = createClient({
  projectId,
  dataset: import.meta.env?.VITE_SANITY_STUDIO_DATASET || 'production',
  apiVersion: '2025-07-02',
  useCdn: isDraftsModeEnabled
    ? false
    : import.meta.env?.NODE_ENV === 'production',
  perspective: isDraftsModeEnabled ? 'drafts' : 'published',
  token: isDraftsModeEnabled ? PREVIEW_TOKEN : '',
});

const builder = imageUrlBuilder(client);

/**
 * Helper function to get optimized image URLs
 * @param source Sanity image reference
 */
export function urlFor(source: SanityImageSource) {
  return builder.image(source);
}
